<template>
    <div>
        <router-link v-if="row.appR == true" :to="row.hashid+'/subset-app-transactions-report'"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                     :title="$t('marketing.dashboard.subset_app_transactions_report')"
        >
            <i class="fa fa-dollar-sign"></i>
        </router-link>
        <router-link v-if="row.pspR == true" :to="row.hashid+'/subset-psp-transactions-report'"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                     :title="$t('marketing.dashboard.subset_psp_transactions_report')"
        >
            <i class="fa fa-cubes"></i>
        </router-link>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {mapGetters} from "vuex";

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
        }
    })
</script>